// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-view-more-statistics-modal .modal2__content {
    padding: 24px 36px;
    overflow: unset;
}

.tournament-view-more-statistics-modal.fairplay .modal2__content {
    padding: 0;
}

.tournament-view-more-statistics-modal .baloa-subtitle-2 {
    color: var(--primary-very-dark-color);
    text-align: right;
}

.tournament-view-more-statistics-modal__fairplay-header{
    display: flex;
    align-items: center;
    margin-top: 24px;
    justify-content: flex-end;
    gap: 60px;
    margin-right: 60px;
}

.tournament-view-more-statistics-modal__fairplay-header .yellow-card {
    background-color: var(--new-yellow-warning-color);
    width: var(--space);
    height: var(--space-and-half);
    cursor: pointer;
    position: relative;
}

.tournament-view-more-statistics-modal__fairplay-header .red-card {
    background-color: var(--error-color);
    width: var(--space);
    height: var(--space-and-half);
    cursor: pointer;
    position: relative;
}

.tournament-view-more-statistics-modal__fairplay-header .blue-card {
    background-color: #0273FF;
    width: var(--space);
    height: var(--space-and-half);
    cursor: pointer;
    position: relative;
}

.tournament-view-more-statistics-modal__fairplay-data {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 40px;
    margin-left: auto;
}

.tournament-view-more-statistics-modal__tooltip {
    visibility: hidden;
    background-color: var(--primary-dark-color);
    color: var(--white-color);
    text-align: center;
    border-radius: 25px;
    padding: 8px 10px;
    white-space: nowrap;

    /* Position the tooltip */
    position: absolute;
    z-index: 1000;
    bottom: 40px;
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc(var(--space-half-quarter) + var(--space-eighth));/* 14px */
    
}

.tournament-view-more-statistics-modal__fairplay-header .yellow-card:hover .tournament-view-more-statistics-modal__tooltip {
    visibility: visible;
    right: -55px;
}

.tournament-view-more-statistics-modal__fairplay-header .red-card:hover .tournament-view-more-statistics-modal__tooltip {
    visibility: visible;
    right: -45px;
}

.tournament-view-more-statistics-modal__fairplay-header .blue-card:hover .tournament-view-more-statistics-modal__tooltip {
    visibility: visible;
    right: -45px;
}

.tournament-view-more-statistics-modal__fairplay-header .icon:hover .tournament-view-more-statistics-modal__tooltip {
    visibility: visible;
    right: -55px;
}

.tournament-view-more-statistics-modal__fairplay-header .baloa-subtitle-2:hover .tournament-view-more-statistics-modal__tooltip {
    visibility: visible;
    right: -65px;
}

.tournament-view-more-statistics-modal__fairplay-header .icon .hubicon-gavel {
    font-size: 24px;
    cursor: pointer;
}

.tournament-view-more-statistics-modal__fairplay-header .icon,
.tournament-view-more-statistics-modal__fairplay-header .baloa-subtitle-2 {
    position: relative;
}

.tournament-view-more-statistics-modal__fairplay-header .baloa-subtitle-2 {
    margin-left: 20px;
}

.tournament-view-more-statistics-modal__fairplay-data .tournament-statistics__scorers-row__goals {
   width: 40px;
   text-align: center;
}

.tournament-view-more-statistics-modal__fairplay-data .tournament-statistics__scorers-row__goals:last-child {
    margin-left: 20px;
}

.tournament-view-more-statistics-modal__fairplay-content {
    padding: 24px 36px;
}

.tournament-view-more-statistics-modal__fairplay-footer {
    border-top: 1px solid var(--new-gray-background-color);
    padding: 16px 36px 24px 36px;
}

.tournament-view-more-statistics-modal__fairplay-footer .baloa-names {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

.tournament-view-more-statistics-modal__fairplay-footer .infolbl {
    margin-top: 16px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.tournament-view-more-statistics-modal__fairplay-footer .infolbl .hubicon-info_v2 {
    font-size: 22px;
    color: var(--new-informative-banner-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .tournament-view-more-statistics-modal .modal2__container {
        margin: 0;
        height: 100%;
        max-height: unset;
        border-radius: 0;
    }

    .tournament-view-more-statistics-modal .modal2__header {
        padding-bottom: 10px;
    }

    .tournament-view-more-statistics-modal .modal2__content {
        padding: 12px;
    }

    .tournament-view-more-statistics-modal__fairplay-content {
        padding: 16px 14px;
    }

    .tournament-view-more-statistics-modal__fairplay-data .tournament-statistics__scorers-row__goals {
        width: 25px;
    }

    .tournament-view-more-statistics-modal__fairplay-data {
        gap: 5px;
    }

    .tournament-view-more-statistics-modal__fairplay-content .tournament-statistics__scorers-row {
        margin-right: 0;
    }

    .tournament-view-more-statistics-modal__fairplay-data .tournament-statistics__scorers-row__goals:last-child {
        margin-left: 5px;
    }

    .tournament-view-more-statistics-modal__fairplay-header{
        margin-top: 12px;
        gap: 15px;
        margin-right: 14px;
    }

    .tournament-view-more-statistics-modal__fairplay-header .baloa-subtitle-2 {
        margin-left: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-view-more-statistics-modal/TournamentViewMoreStatisticsModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,iDAAiD;IACjD,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,2CAA2C;IAC3C,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;;IAEnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,gEAAgE,CAAC,SAAS;;AAE9E;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;GACG,WAAW;GACX,kBAAkB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sDAAsD;IACtD,4BAA4B;AAChC;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,0CAA0C;AAC9C;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,SAAS;QACT,YAAY;QACZ,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".tournament-view-more-statistics-modal .modal2__content {\n    padding: 24px 36px;\n    overflow: unset;\n}\n\n.tournament-view-more-statistics-modal.fairplay .modal2__content {\n    padding: 0;\n}\n\n.tournament-view-more-statistics-modal .baloa-subtitle-2 {\n    color: var(--primary-very-dark-color);\n    text-align: right;\n}\n\n.tournament-view-more-statistics-modal__fairplay-header{\n    display: flex;\n    align-items: center;\n    margin-top: 24px;\n    justify-content: flex-end;\n    gap: 60px;\n    margin-right: 60px;\n}\n\n.tournament-view-more-statistics-modal__fairplay-header .yellow-card {\n    background-color: var(--new-yellow-warning-color);\n    width: var(--space);\n    height: var(--space-and-half);\n    cursor: pointer;\n    position: relative;\n}\n\n.tournament-view-more-statistics-modal__fairplay-header .red-card {\n    background-color: var(--error-color);\n    width: var(--space);\n    height: var(--space-and-half);\n    cursor: pointer;\n    position: relative;\n}\n\n.tournament-view-more-statistics-modal__fairplay-header .blue-card {\n    background-color: #0273FF;\n    width: var(--space);\n    height: var(--space-and-half);\n    cursor: pointer;\n    position: relative;\n}\n\n.tournament-view-more-statistics-modal__fairplay-data {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 40px;\n    margin-left: auto;\n}\n\n.tournament-view-more-statistics-modal__tooltip {\n    visibility: hidden;\n    background-color: var(--primary-dark-color);\n    color: var(--white-color);\n    text-align: center;\n    border-radius: 25px;\n    padding: 8px 10px;\n    white-space: nowrap;\n\n    /* Position the tooltip */\n    position: absolute;\n    z-index: 1000;\n    bottom: 40px;\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc(var(--space-half-quarter) + var(--space-eighth));/* 14px */\n    \n}\n\n.tournament-view-more-statistics-modal__fairplay-header .yellow-card:hover .tournament-view-more-statistics-modal__tooltip {\n    visibility: visible;\n    right: -55px;\n}\n\n.tournament-view-more-statistics-modal__fairplay-header .red-card:hover .tournament-view-more-statistics-modal__tooltip {\n    visibility: visible;\n    right: -45px;\n}\n\n.tournament-view-more-statistics-modal__fairplay-header .blue-card:hover .tournament-view-more-statistics-modal__tooltip {\n    visibility: visible;\n    right: -45px;\n}\n\n.tournament-view-more-statistics-modal__fairplay-header .icon:hover .tournament-view-more-statistics-modal__tooltip {\n    visibility: visible;\n    right: -55px;\n}\n\n.tournament-view-more-statistics-modal__fairplay-header .baloa-subtitle-2:hover .tournament-view-more-statistics-modal__tooltip {\n    visibility: visible;\n    right: -65px;\n}\n\n.tournament-view-more-statistics-modal__fairplay-header .icon .hubicon-gavel {\n    font-size: 24px;\n    cursor: pointer;\n}\n\n.tournament-view-more-statistics-modal__fairplay-header .icon,\n.tournament-view-more-statistics-modal__fairplay-header .baloa-subtitle-2 {\n    position: relative;\n}\n\n.tournament-view-more-statistics-modal__fairplay-header .baloa-subtitle-2 {\n    margin-left: 20px;\n}\n\n.tournament-view-more-statistics-modal__fairplay-data .tournament-statistics__scorers-row__goals {\n   width: 40px;\n   text-align: center;\n}\n\n.tournament-view-more-statistics-modal__fairplay-data .tournament-statistics__scorers-row__goals:last-child {\n    margin-left: 20px;\n}\n\n.tournament-view-more-statistics-modal__fairplay-content {\n    padding: 24px 36px;\n}\n\n.tournament-view-more-statistics-modal__fairplay-footer {\n    border-top: 1px solid var(--new-gray-background-color);\n    padding: 16px 36px 24px 36px;\n}\n\n.tournament-view-more-statistics-modal__fairplay-footer .baloa-names {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.tournament-view-more-statistics-modal__fairplay-footer .infolbl {\n    margin-top: 16px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.tournament-view-more-statistics-modal__fairplay-footer .infolbl .hubicon-info_v2 {\n    font-size: 22px;\n    color: var(--new-informative-banner-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .tournament-view-more-statistics-modal .modal2__container {\n        margin: 0;\n        height: 100%;\n        max-height: unset;\n        border-radius: 0;\n    }\n\n    .tournament-view-more-statistics-modal .modal2__header {\n        padding-bottom: 10px;\n    }\n\n    .tournament-view-more-statistics-modal .modal2__content {\n        padding: 12px;\n    }\n\n    .tournament-view-more-statistics-modal__fairplay-content {\n        padding: 16px 14px;\n    }\n\n    .tournament-view-more-statistics-modal__fairplay-data .tournament-statistics__scorers-row__goals {\n        width: 25px;\n    }\n\n    .tournament-view-more-statistics-modal__fairplay-data {\n        gap: 5px;\n    }\n\n    .tournament-view-more-statistics-modal__fairplay-content .tournament-statistics__scorers-row {\n        margin-right: 0;\n    }\n\n    .tournament-view-more-statistics-modal__fairplay-data .tournament-statistics__scorers-row__goals:last-child {\n        margin-left: 5px;\n    }\n\n    .tournament-view-more-statistics-modal__fairplay-header{\n        margin-top: 12px;\n        gap: 15px;\n        margin-right: 14px;\n    }\n\n    .tournament-view-more-statistics-modal__fairplay-header .baloa-subtitle-2 {\n        margin-left: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
